function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.9998,
  cy: 15.9998,
  r: 15.9998,
  fill: "#FFFFFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13 20.0745V11.5684L20.8518 10.2598V18.7659",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0372 22.0372C12.1213 22.0372 13.0001 21.1584 13.0001 20.0743C13.0001 18.9902 12.1213 18.1113 11.0372 18.1113C9.95306 18.1113 9.07422 18.9902 9.07422 20.0743C9.07422 21.1584 9.95306 22.0372 11.0372 22.0372Z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8887 20.7286C19.9728 20.7286 20.8517 19.8498 20.8517 18.7657C20.8517 17.6816 19.9728 16.8027 18.8887 16.8027C17.8046 16.8027 16.9258 17.6816 16.9258 18.7657C16.9258 19.8498 17.8046 20.7286 18.8887 20.7286Z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.741c83a478e11fe131a6a89eecb1541f.svg";
export { ForwardRef as ReactComponent };